import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

export default function PaymentSuccess() {
  const { t } = useTranslation();
  const { refresh } = useAuth();

  useEffect(() => {
    // Webhook handler runs server-side; refresh user state once it lands.
    const tries = [500, 1500, 3500];
    tries.forEach((ms) => setTimeout(() => refresh(), ms));
  }, [refresh]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 mb-5">
          <CheckCircle2 className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">{t('payment.successTitle')}</h1>
        <p className="text-slate-600 mb-6">{t('payment.successBody')}</p>
        <Link to="/dashboard">
          <Button className="w-full">
            {t('payment.goDashboard')} <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </Link>
      </Card>
    </div>
  );
}
